import project from './project';
import guaranteeCompany from './guaranteeCompany';
import bidder from './bidder';

export default {
  project,
  guaranteeCompany,
  bidder,
};
